import React from 'react';
import StudentPerformanceBar from 'legacy-src/components/assessment/Results/StudentPerformanceBar';
import {
  learnosityReportByUsers,
  studentsByScoreBracket,
} from 'legacy-src/utility/progressHelpers';
import isEmpty from 'lodash/isEmpty';
import { Icon } from 'legacy-packages/ft-cb';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import { Link } from 'react-router';
import uniqid from 'uniqid';
import {
  ALL_SCHOOLS,
  ALL_STUDENTS,
  ALL_SECTIONS,
  DEFAULT_STUDENT,
  INITIAL_DISTRICTS,
} from 'legacy-src/utility/Filters';

export const renderPerformanceBar = ({
  studentScore,
  progress,
  studentSubmission,
  linkProps,
  isTabbable = true,
}) => {
  const ConditionalLinked = ({ children }) => {
    if (!isEmpty(linkProps)) {
      return <Link {...linkProps}>{children}</Link>;
    }

    return children;
  };

  if (studentScore && !isEmpty(studentScore)) {
    return (
      <StudentPerformanceBar
        studentScore={studentScore}
        progress={progress}
        linkProps={linkProps}
        isTabbable={isTabbable}
      />
    );
  } else if (
    studentSubmission &&
    studentSubmission.status !== 'not_started' &&
    isEmpty(studentScore)
  ) {
    return (
      <ConditionalLinked>
        <div className="flex justify-center">
          <p className="italic">Awaiting scoring</p>
        </div>
      </ConditionalLinked>
    );
  }

  return (
    <ConditionalLinked>
      <div className="flex justify-center">
        <p className="italic">No results</p>
      </div>
    </ConditionalLinked>
  );
};

export const renderTimeTaken = (assignmentTimer, timeTaken) => {
  let className = 'rh__performance_label_normal';
  let displayedValue = '-';
  if (timeTaken) {
    if (timeTaken > 200) {
      className = 'rh__performance_label_over_time_200';
    } else if (timeTaken > assignmentTimer) {
      className = 'rh__performance_label_over_time';
    }
    displayedValue = timeTaken > 200 ? '200+' : timeTaken;
  }
  return (
    <span className="rh__performance_wrap">
      <Icon className={className} name="stopwatch" size="1.2em" />
      <h3 className={className}>
        {displayedValue}/{assignmentTimer} min
      </h3>
    </span>
  );
};

export const getPerformanceStacks = (
  learnosityReportsData,
  studentId,
  itemId,
) => {
  if (learnosityReportsData && learnosityReportsData.length) {
    const reportByStudents = learnosityReportByUsers(learnosityReportsData);

    const [result] = studentsByScoreBracket({
      userIds: [studentId],
      reportByUsers: reportByStudents,
      itemId,
    });

    return result;
  }
  return undefined;
};

export const Skills = ({ skills }) => {
  if (!skills) return null;

  return skills.map((tag) => {
    const popoverContentId = `skills-column-popover-content-${uniqid()}`;
    return (
      <PopOver
        key={tag.tagId}
        accessibility={{
          'aria-describedby': popoverContentId,
        }}
        trigger={tag.label}
      >
        <div id={popoverContentId}>{tag.description}</div>
      </PopOver>
    );
  });
};

export const getSkillsFromRelatedSkills = (relatedSkills = []) => {
  const relatedSkillCategory = relatedSkills.find((skill) =>
    skill.title.match(/Skill|Practice/),
  );
  if (
    !relatedSkillCategory ||
    !relatedSkillCategory.children ||
    !relatedSkillCategory.children.length
  ) {
    return;
  }
  const skillsList = relatedSkillCategory.children.map((item) => ({
    category: item.category,
    label: item.label.replace('Skill ', '').replace('Practice ', ''),
    name: item.description,
  }));
  return skillsList;
};

export const filterResultsUsingGroupFilter = ({ results, filterProps }) =>
  results.reduce(
    (accum, result) =>
      result.assignees.some(
        (assignee) =>
          // DISTRICT, SCHOOL, AND SECTION is selected
          (filterProps.activeDistrict.value > 0 &&
            assignee.district_id === filterProps.activeDistrict.value &&
            filterProps.activeSchool.value > 0 &&
            assignee.parent_id === filterProps.activeSchool.value &&
            filterProps.activeSection.value > 0 &&
            assignee.id === filterProps.activeSection.value) ||
          // DISTRICT and "ALL SCHOOLS" IS SELECTED
          (filterProps.activeDistrict.value > 0 &&
            assignee.district_id === filterProps.activeDistrict.value &&
            filterProps.activeSchool.value === ALL_SCHOOLS.value) ||
          // DISTRICT and SCHOOL and "ALL CLASSES" or "ALL STUDENTS" is selected
          (filterProps.activeDistrict.value > 0 &&
            assignee.district_id === filterProps.activeDistrict.value &&
            filterProps.activeSchool.value > 0 &&
            assignee.parent_id === filterProps.activeSchool.value &&
            (filterProps.activeSection.value === ALL_SECTIONS.value ||
              filterProps.activeSection.value === ALL_STUDENTS.value) &&
            filterProps.activeStudent.value < 0) ||
          // DISTRICT and "ALL CLASSES" and STUDENT and SCHOOL is selected
          (filterProps.activeDistrict.value > 0 &&
            assignee.district_id === filterProps.activeDistrict.value &&
            filterProps.activeSchool.value > 0 &&
            assignee.parent_id === filterProps.activeSchool.value &&
            (filterProps.activeSection.value === ALL_SECTIONS.value ||
              filterProps.activeSection.value === ALL_STUDENTS.value) &&
            filterProps.activeStudent.value !== DEFAULT_STUDENT.value &&
            assignee.id ===
              parseInt(filterProps.activeStudent.value.split('-')[0], 10)) ||
          // ALL DISTRICTS ONLY
          filterProps.activeDistrict.value ===
            INITIAL_DISTRICTS.defaultValue.value,
      )
        ? [...accum, result]
        : accum,
    [],
  );
